module.exports = __webpack_public_path__ + "static/header-8529250ef0fed109a6c77caf3a77323b.jpg";